<template>
  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
    <tr v-if="block.text || !(block.button_url && block.button_text)">
      <td style="padding: 0 10px; font-size: 15px; line-height: 20px; color: #555555;">
        <div v-html="replacePlaceholders(block.text || '&nbsp;<br/>&nbsp;', placeholders)" style="margin: 0 10px;"></div>
      </td>
    </tr>
    <tr v-if="block.button_url && block.button_text">
      <td style="padding: 0 10px;">
        <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" style="margin: auto;">
          <tr>
            <td class="button-td button-td-primary" :style="`padding-bottom: 10px; border-radius: ${button_radius !== null ? button_radius : 4}px;`">
              <a class="button-a button-a-primary" :href="ensureUrl(block.button_url)" :style="`background: ${button_color}; border: 1px solid ${button_color}; font-size: 15px; line-height: 15px; text-decoration: none; padding: 13px 17px; color: ${buttonTextColor}; display: block; border-radius: ${button_radius !== null ? button_radius : 4}px;`" target="_blank">{{ block.button_text }}</a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>
<style>
  ol>li ol>li {list-style-type: lower-alpha;}
</style>
<script>
  export default {
    props: {
      block: Object,
      button_color: String,
      button_radius: Number,
      placeholders: Object,
    },
    data() {
      return {
        ensureUrl: _.ensureUrl,
      }
    },
    computed: {
      buttonTextColor() {
        return _.hexContrastColor(this.button_color)
      },
    },
    methods: {
      replacePlaceholders: _.replacePlaceholders,
    },
  }
</script>